var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Prop } from 'vue-property-decorator';
import _, { cloneDeep } from "lodash";
import VueDialog from "../../../interface/IVueDialog";
import BusinessGoodsPriceService from '../../../api/BusinessGoodsPriceService';
import { initClientsRight, formateClientsByGroupTree, createResultByClientsRight, fixBusinessIdsContainGroupNotHasChildren, checkedTempGroupData } from '../../../helper/businessGoodsPriceFunc';
var Dialog = (function (_super) {
    __extends(Dialog, _super);
    function Dialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.clients = [];
        _this.clientsRight = [];
        _this.clientsAll = [];
        _this.supplier_to_business_ids = [];
        _this.business_ids_other = [];
        _this.group_ids = [];
        _this.needCheckedIsTemp = false;
        _this.disabled = false;
        _this.requiredChooseNum = true;
        _this.leftKeyword = '';
        _this.rightKeyword = '';
        _this.rightTreeReady = false;
        _this.defaultProps = {
            label: 'business_name',
            id: "supplier_to_business_id",
        };
        _this.clientStatus = null;
        _this.cooperation_status = '1';
        _this.clientStatusSelectedMap = {};
        _this.totalSelected = [];
        return _this;
    }
    Dialog.prototype.calcTotalSelect = function () {
        var businessIds = [];
        if (Object.keys(this.clientStatusSelectedMap).length === 0) {
            businessIds.push.apply(businessIds, this.supplier_to_business_ids);
        }
        else {
            for (var status in this.clientStatusSelectedMap) {
                var ids = this.clientStatusSelectedMap[status] || [];
                businessIds.push.apply(businessIds, ids);
            }
        }
        this.totalSelected = Array.from(new Set(businessIds));
    };
    Dialog.prototype.created = function () {
        this.service = BusinessGoodsPriceService.getInstance();
    };
    Dialog.prototype.mounted = function () {
        this.getClients(false);
        this.getClients(true);
    };
    Dialog.prototype.filterNode = function (value, data) {
        if (!value)
            return true;
        return data.business_name.indexOf(value) !== -1;
    };
    Dialog.prototype.filterNodeRight = function (value, data) {
        if (data.nodeType == 'business' && !data.isChk) {
            return false;
        }
        if (data.nodeType == 'business_group') {
            if (data.children.length > 0) {
                if (!data.chkChildrensNum) {
                    return false;
                }
            }
            else {
                if (data.is_set_group != 1) {
                    return false;
                }
            }
        }
        if (!value)
            return true;
        return data.business_name.indexOf(value) !== -1;
    };
    Dialog.prototype.updateClientsRightByBusinessIds = function () {
        var _this = this;
        this.calcTotalSelect();
        var businessIds = this.totalSelected;
        console.log('updateClientsRightByBusinessIds businessIds>>>', businessIds, this.clientsRight);
        if (this.clientsRight.length === 0) {
            var filterIds = this.totalSelected.length ? this.totalSelected : this.supplier_to_business_ids;
            console.log('filterIds>>>', filterIds);
            this.clientsRight = initClientsRight(_.cloneDeep(this.clientsAll), filterIds, this.group_ids);
            this.supplier_to_business_ids = fixBusinessIdsContainGroupNotHasChildren(this.clientsRight, this.supplier_to_business_ids, this.group_ids);
            setTimeout(function () {
                _this.searchRight();
                _this.rightTreeReady = true;
            }, 300);
        }
        else {
            this.clientsRight = initClientsRight(this.clientsRight, businessIds);
        }
        this.searchRight();
    };
    Dialog.prototype.updateClientsRightIsSetGroup = function (clientsRight, group_id, checked) {
        clientsRight.forEach(function (v) {
            if (v.group_id == group_id) {
                v.is_set_group = checked ? 1 : 0;
            }
        });
    };
    Dialog.prototype.handleCheckChange = function (data, checked, indeterminate) {
        if (data.nodeType == 'business_group') {
            this.updateClientsRightIsSetGroup(this.clientsRight, data.group_id, checked);
        }
        var business_ids_all = [];
        var supplier_to_business_ids = this.$refs.tree.getCheckedKeys(true);
        var oldSelectedIds = this.clientStatusSelectedMap[this.cooperation_status] || [];
        this.supplier_to_business_ids = supplier_to_business_ids;
        oldSelectedIds = oldSelectedIds.filter(function (item) { return supplier_to_business_ids.includes(item); });
        supplier_to_business_ids.forEach(function (id) {
            if (!oldSelectedIds.includes(id))
                oldSelectedIds.push(id);
        });
        this.clientStatusSelectedMap[this.cooperation_status] = oldSelectedIds;
        console.log('handleCheckChange>>>', supplier_to_business_ids, oldSelectedIds, this.clientStatusSelectedMap);
        this.updateClientsRightByBusinessIds();
    };
    Dialog.prototype.delClient = function (node, data) {
        var _this = this;
        var statusKeys = Object.keys(this.clientStatus);
        statusKeys.forEach(function (key) {
            var list = _this.clientStatusSelectedMap[key] || [];
            var index = list.indexOf(data.supplier_to_business_id);
            if (index > -1)
                _this.clientStatusSelectedMap[key].splice(index, 1);
        });
        this.supplier_to_business_ids = this.supplier_to_business_ids.filter(function (id) {
            return id != data.supplier_to_business_id;
        });
        this.updateClientsRightByBusinessIds();
        this.$refs.tree.setCheckedKeys(this.supplier_to_business_ids);
    };
    Dialog.prototype.changeRightGroupIsSetGroup = function (node, data) {
        if (data.nodeType == 'business_group' && data.children.length == 0 && data.is_set_group != 1) {
            this.supplier_to_business_ids = this.supplier_to_business_ids.filter(function (id) {
                return id != data.supplier_to_business_id;
            });
            this.updateClientsRightByBusinessIds();
            this.$refs.tree.setCheckedKeys(this.supplier_to_business_ids);
        }
    };
    Dialog.prototype.clearAllClient = function (node, data) {
        this.supplier_to_business_ids = [];
        this.clientStatusSelectedMap = {};
        this.updateClientsRightByBusinessIds();
        this.$refs.tree.setCheckedKeys(this.supplier_to_business_ids);
    };
    Dialog.prototype.getClients = function (isAll) {
        var _this = this;
        console.log('getClients>>>', this.needCheckedIsTemp, isAll, this.clientsAll);
        return new Promise(function (resolve) {
            if (true !== isAll) {
                _this.service.getClientsByGroupTree({
                    business_status: _this.cooperation_status
                }).then(function (res) {
                    _this.clients = formateClientsByGroupTree(res.data.data || []);
                }).finally(function () {
                    resolve();
                });
            }
            else {
                _this.service.getClientsByGroupTree({ business_status: -1 }).then(function (res) {
                    if (_this.needCheckedIsTemp) {
                        var tempGroupData = checkedTempGroupData(_.cloneDeep(_this.clients));
                        _this.supplier_to_business_ids = tempGroupData.supplier_to_business_ids;
                        _this.group_ids = tempGroupData.group_ids;
                    }
                    res.data.data = formateClientsByGroupTree(res.data.data);
                    _this.clientsAll = res.data.data || [];
                    _this.calcTotalSelect();
                    var filterIds = _this.totalSelected.length ? _this.totalSelected : _this.supplier_to_business_ids;
                    console.log('filterIds>>>', _this.totalSelected);
                    _this.clientsRight = initClientsRight(_.cloneDeep(_this.clientsAll), filterIds, _this.group_ids);
                    _this.supplier_to_business_ids = fixBusinessIdsContainGroupNotHasChildren(_this.clientsRight, _this.supplier_to_business_ids, _this.group_ids);
                    setTimeout(function () {
                        _this.searchRight();
                        _this.rightTreeReady = true;
                    }, 300);
                    console.log(211, _this.clientsAll);
                }).finally(function () {
                    resolve();
                });
            }
        });
    };
    Dialog.prototype.changeStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.supplier_to_business_ids = cloneDeep(this.clientStatusSelectedMap[this.cooperation_status] || []);
                        return [4, this.getClients(false)];
                    case 1:
                        _a.sent();
                        this.$refs.tree.setCheckedKeys(this.supplier_to_business_ids);
                        return [2];
                }
            });
        });
    };
    Dialog.prototype.search = function () {
        this.$refs.tree.filter(this.leftKeyword);
    };
    Dialog.prototype.searchRight = function () {
        this.$refs.rightTree.filter(this.rightKeyword);
    };
    Dialog.prototype.close = function () {
        this.$closeDialog();
    };
    Dialog.prototype.applyData = function () {
        if (this.requiredChooseNum) {
            if (this.totalSelected.length === 0) {
                this.$message.warning('请选择客户');
                return;
            }
        }
        var data = createResultByClientsRight(this.clientsRight);
        this.$emit("submit", data);
        this.close();
    };
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], Dialog.prototype, "showEmpty", void 0);
    Dialog = __decorate([
        Component({})
    ], Dialog);
    return Dialog;
}(VueDialog));
export default Dialog;
